/**
 * Shared dependencies from the Host
 * @type {Record<string, import('@nx/module-federation').SharedLibraryConfig>}
 */
const sharedDeps = {
  'app-zephyr-axios': { singleton: true, requiredVersion: false },
  'app-zephyr-environment': { singleton: true, requiredVersion: false },
  'app-zephyr-domains': { singleton: true, requiredVersion: false },
  react: { singleton: true, requiredVersion: false },
  'react-dom': { singleton: true, requiredVersion: false },
  'react/jsx-runtime': { singleton: true, requiredVersion: false },
  'react/jsx-dev-runtime': { singleton: true, requiredVersion: false },
  'react-helmet-async': { singleton: true, requiredVersion: false },
  '@tanstack/react-query': { singleton: true, requiredVersion: false },
  '@tanstack/react-router': { singleton: true, requiredVersion: false },
  '@emotion/react': { singleton: true, requiredVersion: false },
  '@mui/material': { singleton: true, requiredVersion: false },
  '@mui/styles': { singleton: true, requiredVersion: false },
  'tss-react/mui': { singleton: true, requiredVersion: false },
  rsuite: { singleton: true, requiredVersion: false },
  '@stripe/react-stripe-js': { singleton: true, requiredVersion: false },
  '@stripe/stripe-js': { singleton: true, requiredVersion: false },
  stripe: { singleton: true, requiredVersion: false },
};

/**
 * Plugin used to insert a GlobalPlugin that will be responsible for overriding
 * shared dependencies with an instance of the Host.
 * @type {() => import('@module-federation/enhanced/runtime').FederationRuntimePlugin}
 */
const runtimePlugin = () => ({
  name: 'ZephyrCloudRuntimePlugin',
  beforeInit: (config) => {
    // Push custom plugin to the MF GLOBAL registry to run on every remote.
    // eslint-disable-next-line no-undef
    __FEDERATION__.__GLOBAL_PLUGIN__.push({
      name: 'override-deps-plugin',
      // Allows manual resolution of shared module requests.
      resolveShare(args) {
        const { shareScopeMap, scope, pkgName, version, GlobalFederation } = args;
        // The first entry on the global MF instances will always be the host.
        const host = GlobalFederation.__INSTANCES__[0];

        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!sharedDeps[pkgName]) return args;

        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!host.options.shared[pkgName]?.[0]) return args;

        // Resolver function gets called to get the requested dependencies.
        // We replace the resolver function
        // Replace the dependency with the host's to override whichever one they are using.
        args.resolver = function () {
          shareScopeMap[scope][pkgName][version] = host.options.shared[pkgName][0];
          return shareScopeMap[scope][pkgName][version];
        };
        return args;
      },
    });
    return config;
  },
});

module.exports = runtimePlugin;
module.exports.sharedDeps = sharedDeps;
